import type { Me } from '../api.js';
import type { AuthUser } from '../auth.js';
import { Button, Segmented } from '../ui/index.js';
import { planName } from './Credits.js';

export type Theme = 'dark' | 'light';
export function SettingsPage({ me, user, theme, onTheme, onSignOut }: { me: Me; user: AuthUser; theme: Theme; onTheme: (t: Theme) => void; onSignOut: () => void }) {
  return (
    <section className="rv-page">
      <header className="rv-page__head"><h1 className="rv-title">Settings</h1></header>
      <dl className="rv-facts">
        <dt>Signed in as</dt><dd>{user.email ?? user.uid}</dd>
        <dt>Workspace</dt><dd>{me.org.id} · {planName(me.org.plan)} · you are {me.me.role}</dd>
      </dl>
      <div className="rv-row"><span className="rv-field__label">Theme</span><Segmented label="Theme" options={[{ id: 'dark', label: 'Dark' }, { id: 'light', label: 'Light' }]} value={theme} onChange={(id) => onTheme(id as Theme)} /></div>
      <div><Button icon="log-out" onClick={onSignOut}>Sign out</Button></div>
    </section>
  );
}
